export const formatPositionTitle = ({
  name,
  workstream,
}: {
  name?: string | null;
  workstream?: string | null;
}): string => {
  const normalizedName = name?.trim() ?? '';
  const normalizedWorkstream = workstream?.trim() ?? '';

  if (!normalizedWorkstream) return normalizedName;
  if (!normalizedName) return normalizedWorkstream;

  return `${normalizedWorkstream}: ${normalizedName}`;
};
